import template from './email.jade';
import inlineValidationTemplate from './email-inline-validation.jade';

export default angular
  .module('app.directives.email', [])
  .directive('email', () => ({
    restrict: 'E',
    template(element, attrs) {
      // Toggle for using new validation markup/styles
      if ('inlineValidation' in attrs) {
        return inlineValidationTemplate;
      } else {
        return template;
      }
    },
    scope: {
      email: '=?',
      form: '=?',
      showLabel: '=',
    },
  }));
